module.exports = __webpack_public_path__ + "public/images/chef.40119927b6a6aa0911e12eb030f7dc2f.webp";